// src/hooks/useBootstrapSettings.ts
import { useEffect, useState } from "react";
import { getDeviceSettings } from "../services/deviceSettings";

export function useBootstrapSettings() {
  const [shouldOpen, setShouldOpen] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const s = await getDeviceSettings(["printer_ip", "fiscal_ip"]);
        const need = (!s["printer_ip"] || String(s["printer_ip"]).trim() === "") &&
                     (!s["fiscal_ip"] || String(s["fiscal_ip"]).trim() === "");
        setShouldOpen(need);
      } catch {
        setShouldOpen(true); // ako nema DB, prvi put
      }
    })();
  }, []);

  return shouldOpen;
}
